import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "absolute z-[9999] bg-white bottom-2 right-5 w-96 shadow-lg rounded"
};
const _hoisted_2 = { class: "bg-[#EAECF0] h-10 flex justify-between items-center px-3 rounded-tr rounded-tl" };
const _hoisted_3 = { class: "flex items-center w-14 justify-between" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = {
    key: 0,
    class: "py-2 h-52 scrollable-dialog px-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_UITextSmMedium = _resolveComponent("UITextSmMedium");
    const _component_ChevronUpIcon = _resolveComponent("ChevronUpIcon");
    const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon");
    const _component_XCloseIcon = _resolveComponent("XCloseIcon");
    const _component_UploadingItem = _resolveComponent("UploadingItem");
    return (_ctx.uploadQueue.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_UITextSmMedium, null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.uploading')) + " " + _toDisplayString(_ctx.uploadQueue.length) + " " + _toDisplayString(_ctx.$t('common.items')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                        class: "cursor-pointer",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.toggleCollapseContent && _ctx.toggleCollapseContent(...args)))
                    }, [
                        (_ctx.collapseContent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_ChevronUpIcon, { class: "w-5 h-5" })
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_ChevronDownIcon, { class: "w-5 h-5" })
                            ]))
                    ]),
                    _createElementVNode("div", {
                        class: "cursor-pointer",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.closeUploadIndicator && _ctx.closeUploadIndicator(...args)))
                    }, [
                        _createVNode(_component_XCloseIcon, { class: "w-5 h-5" })
                    ])
                ])
            ]),
            (!_ctx.collapseContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadQueue, (file, index) => {
                        return (_openBlock(), _createBlock(_component_UploadingItem, {
                            key: index,
                            file: file
                        }, null, 8 /* PROPS */, ["file"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]))
                : _createCommentVNode("v-if", true)
        ]))
        : _createCommentVNode("v-if", true);
}
